<template>
    <input
        type="tel"
        class="form-control"
        ref="input"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
export default {
    props: {
        value: [String, Number, null],
        pattern: {
            type: RegExp,
        }
    },
    mounted: function() {
        this.updateValue(this.value);
    },
    watch: {
        value: function(value) {
            this.updateValue(value);
        }
    },
    methods: {
        updateValue: function(value) {
            if (typeof value == 'string') {
                value = value.replace(/[^0-9.]/g, '');
                
                if (value) {
                    value = parseFloat(value);
                };
            }
            
            if (value) {
                this.$refs.input.value = value.toLocaleString();
            } else {
                this.$refs.input.value = '';
            }

            if (value != this.value) {
                this.$emit('input', value);
            }
        }
    }
}
</script>